var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient18);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st6 {\n        isolation: isolate;\n      }\n\n      .st7 {\n        fill: url(#linear-gradient19);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st15 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st16 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st17 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st18 {\n        fill: url(#linear-gradient);\n      }\n\n      .st19 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st19, .st20 {\n        mix-blend-mode: screen;\n      }\n\n      .st20 {\n        fill: url(#linear-gradient9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 50,
    y1: 7.14,
    x2: 50,
    y2: 76.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#68dae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2071ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 50,
    y1: 99.28,
    x2: 50,
    y2: 41.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68dae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2071ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 50,
    y1: 70.2,
    x2: 50,
    y2: 96.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 9.2,
    y1: 25.67,
    x2: 29.41,
    y2: 59.91,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 80.7,
    y1: 38.76,
    x2: 68.35,
    y2: 69.63,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: -3.05,
    y1: 20.52,
    x2: 23.9,
    y2: 43.54,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 102.57,
    y1: 26.87,
    x2: 63.27,
    y2: 52.13,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 12.78,
    y1: 41.86,
    x2: 87.22,
    y2: 41.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 50,
    y1: 0.72,
    x2: 50,
    y2: 83.01,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 50,
    y1: 11.82,
    x2: 50,
    y2: 71.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2071ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 50,
    y1: 58.28,
    x2: 50,
    y2: 25.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 37.69,
    y1: 41.86,
    x2: 62.31,
    y2: 41.86,
    xlinkHref: "#linear-gradient9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 44.35,
    y1: 28.82,
    x2: 44.35,
    y2: 41.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 55.65,
    y1: 41.86,
    x2: 55.65,
    y2: 28.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 50,
    y1: 41.86,
    x2: 50,
    y2: 41.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: 55.65,
    y1: 48.39,
    x2: 55.65,
    y2: 35.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: 55.65,
    y1: 54.91,
    x2: 55.65,
    y2: 41.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: 44.35,
    y1: 41.86,
    x2: 44.35,
    y2: 54.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: 44.35,
    y1: 48.39,
    x2: 44.35,
    y2: 35.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient19",
    x1: 50,
    y1: 33.28,
    x2: 50,
    y2: 50.45,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M50,76.58c-1.71,0-3.39-.45-4.87-1.31l-21.63-12.49c-3.01-1.74-4.87-4.97-4.87-8.44v-24.97c0-3.47,1.87-6.71,4.87-8.44l21.63-12.49c1.48-.85,3.16-1.31,4.87-1.31s3.39.45,4.87,1.31l21.63,12.49c3.01,1.74,4.87,4.97,4.87,8.44v24.97c0,3.47-1.87,6.71-4.87,8.44l-21.63,12.49c-1.48.85-3.16,1.31-4.87,1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "34.35 41.86 34.35 90.25 50 99.28 65.65 90.25 65.65 41.86 34.35 41.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.69 88.9 36.69 44.2 63.31 44.2 63.31 88.9 50 96.58 36.69 88.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M6.37,55.93l39.15,22.61v-28.48L2.24,25.06v23.71c0,2.95,1.57,5.68,4.13,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.48,50.05v28.48l39.15-22.61c2.56-1.48,4.13-4.2,4.13-7.16v-23.71l-43.29,24.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M6.37,48.13l39.15,22.61v-28.48L2.24,17.27v23.71c0,2.95,1.57,5.68,4.13,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M54.48,42.26v28.48l39.15-22.61c2.56-1.48,4.13-4.2,4.13-7.16v-23.71l-43.29,24.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.22,54.35v-24.97c0-5.57-2.97-10.72-7.8-13.51L57.8,3.39c-4.83-2.79-10.77-2.79-15.59,0l-21.63,12.49c-4.83,2.79-7.8,7.93-7.8,13.51v24.97c0,5.57,2.97,10.72,7.8,13.51l21.63,12.49c4.83,2.79,10.77,2.79,15.59,0l21.63-12.49c4.83-2.79,7.8-7.93,7.8-13.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50,83.01c-2.8,0-5.59-.72-8.09-2.16l-21.63-12.49c-4.99-2.88-8.09-8.25-8.09-14.01v-24.97c0-5.76,3.1-11.13,8.09-14.01L41.91,2.88C46.9,0,53.1,0,58.09,2.88l21.63,12.49c4.99,2.88,8.09,8.25,8.09,14.01v24.97c0,5.76-3.1,11.13-8.09,14.01l-21.63,12.49c-2.49,1.44-5.29,2.16-8.09,2.16ZM50,1.89c-2.6,0-5.19.67-7.5,2l-21.63,12.49c-4.63,2.67-7.5,7.65-7.5,13v24.97c0,5.35,2.88,10.33,7.5,13l21.63,12.49c4.63,2.67,10.38,2.67,15.01,0l21.63-12.49c4.63-2.67,7.51-7.65,7.51-13v-24.97c0-5.35-2.88-10.33-7.5-13L57.51,3.89c-2.31-1.34-4.91-2-7.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M50,71.91c-.89,0-1.76-.23-2.53-.68l-21.63-12.49c-1.56-.9-2.53-2.58-2.53-4.39v-24.97c0-1.8.97-3.49,2.53-4.39l21.63-12.49c.77-.44,1.65-.68,2.53-.68s1.76.23,2.53.68l21.63,12.49c1.56.9,2.53,2.58,2.53,4.39v24.97c0,1.81-.97,3.49-2.53,4.39l-21.63,12.49c-.77.44-1.65.68-2.53.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.78 50.07 35.78 33.65 50 25.44 64.22 33.65 64.22 50.07 50 58.28 35.78 50.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "37.69 48.97 37.69 34.76 50 27.65 62.31 34.76 62.31 48.97 50 56.08 37.69 48.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "50 28.82 50 28.82 38.7 35.34 50 41.86 50 28.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "50 41.86 61.3 35.34 61.3 35.34 50 28.82 50 41.86 50 41.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "50 41.86 50 41.86 50 41.86 50 41.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "50 41.86 61.3 48.39 61.3 35.34 50 41.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "50 41.86 50 54.91 50 54.91 61.3 48.39 61.3 48.39 50 41.86 50 41.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "38.7 48.39 38.7 48.39 50 54.91 50 41.86 38.7 48.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "50 41.86 38.7 35.34 38.7 35.34 38.7 48.39 50 41.86 50 41.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "50 33.28 50 33.28 42.57 37.57 42.57 37.57 42.57 46.16 42.57 46.16 50 50.45 50 50.45 57.43 46.16 57.43 46.16 57.43 37.57 57.43 37.57 50 33.28"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPackage);
export default __webpack_public_path__ + "static/media/BASIC-PACKAGE.4e9d9417cf703a97a2e3665e67aa224f.svg";
export { ForwardRef as ReactComponent };